import type {Relation} from "typeorm";
import {Column, Entity, JoinColumn, ManyToOne, OneToMany, OneToOne} from "typeorm";
import {BaseEntity} from "@/modules/base/entity";
import {MaxLength} from "class-validator";
import {Match} from "@/modules/match/entity";
import {Division} from ".";
import {Season} from "@/modules/season/entity";

@Entity({
  orderBy: {
    id: "ASC",
  },
})
export class Matchday extends BaseEntity {
  @ManyToOne(() => Season)
  season: Relation<Season>;

  @Column({type: 'varchar', length: '50'})
  @MaxLength(50)
  name: string;

  @Column({type: "date"})
  scheduledAt: Date;

  @OneToOne(() => Matchday, matchday => matchday.prev)
  next?: Relation<Matchday>;

  @OneToOne(() => Matchday, matchday => matchday.next)
  @JoinColumn()
  prev?: Relation<Matchday>;

  @ManyToOne(() => Division, division => division.matchdays)
  division: Relation<Division>;

  @OneToMany(() => Match, match => match.matchday)
  matches: Relation<Match[]>;

  @Column({type: 'boolean'})
  finished = false;

  @Column({type: 'boolean'})
  current = false;
}
